import { Component, OnInit, inject } from '@angular/core';
import { HelpStore } from '../../stores';
import { SEOService } from '../../services';
import { TranslocoModule } from '@ngneat/transloco';
import { RouterLink } from '@angular/router';
import { ContactFormComponent } from '../../shared/components/contact-form/contact-form.component';
import { ROUTES } from '../../routes.constants';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  standalone: true,
  imports: [
    TranslocoModule,
    RouterLink,
    ContactFormComponent,
  ],
})
export class ContactComponent implements OnInit {
  private seoService = inject(SEOService);
  private helpStore = inject(HelpStore);
  ROUTES = ROUTES;

  ngOnInit(): void {
    this.seoService.updateTitle('Contact');
    const resetInfos = {
      context: null,
      subject: null,
      event: null,
    };
    this.helpStore.loadContactInfo({...this.helpStore.getContactInfo(), ...resetInfos});
  }

}
